<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { page } from '$app/stores';
    import { NextPageNavigator } from '$lib/global/helper/NextPageNavigator';
    import { getColor } from '$lib/helper';
    import { advancedLinking } from '$lib/Stores/stores';
    import { handleLinkingNavigation, getLinkingPreloadTarget } from '$lib/utils/linkingNavigation';
    import { getAllUserAnswers } from '$lib/utils/userAnswerStorage';

    import get from 'lodash/get';

    import IconView from './Icon.View.svelte';

    import type { IconContent } from '$lib/types/Components/Icon/IconContent';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let content: IconContent;
    export let theme: Theme;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;
    export let nextPage = '';
    export let campaignId = '';
    export let campaignVersionId = '';
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];

    const {
        data: { pageIdSlugMap },
    } = $page;

    const originalLogicNextPage: string = get(content, 'linking.pageId', nextPage);
    const linkingComponentId = get(content, 'linking.componentId');
    const externalLink: string = get(content, 'linking.url', '');
    const isNewTab: boolean = get(content, 'linking.isNewTab', false);

    const nextPageNavigator = new NextPageNavigator(
        campaignId,
        firstResultPage,
        pageIdSlugMap,
        trackingProperties,
    );

    const handleClick = async () => {
        if (!content.linkingEnabled) {
            return;
        }

        return handleLinkingNavigation({
            componentId: id,
            userAnswers: getAllUserAnswers(campaignVersionId),
            advancedLinking: $advancedLinking,
            nextPageNavigator,
            originalLogicNextPage,
            nextPage,
            externalLink,
            isExternal: !content.linking?.isInternal && !!externalLink,
            isNewTab,
            currentPageId: $page.data.pageId,
            linkingComponentId,
        });
    };

    const handleMouseEnter = () => {
        if (!content.linkingEnabled) {
            return;
        }

        const { pageId, isExternal } = getLinkingPreloadTarget({
            componentId: id,
            userAnswers: getAllUserAnswers(campaignVersionId),
            advancedLinking: $advancedLinking,
            nextPageNavigator,
            originalLogicNextPage,
            nextPage,
            isExternal: !content.linking?.isInternal && !!externalLink,
        });

        nextPageNavigator.preload(pageId, isExternal);
    };
</script>

<IconView
    {id}
    svg={content.svg}
    iconName={content.iconName}
    platform={content.platform}
    icon={content.icon}
    size={content.size}
    align={content.align}
    box={content.box}
    color={getColor(content.color, theme.fontColor)}
    isAnimated={content.isAnimated}
    jsonUrl={content.jsonUrl}
    linkingEnabled={content.linkingEnabled}
    onClick={handleClick}
    onMouseEnter={handleMouseEnter}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
